import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const CompanyIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 21V5l8-2v18M12 8h8v13M2 21h20" />
      <path d="M7 7h2M7 11h2M7 15h2M15 11h2M15 15h2M7 21v-3h2" />
    </g>
  </SvgIcon>
)

export default CompanyIcon
